// @ts-nocheck

import { createAsyncThunk } from '@reduxjs/toolkit';

import { Post, Get, Put } from "../../utils/apiUtils";


export const DashboardExtraReducer = (builder) => {
    builder
        .addCase(addKpiToDashboard.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(addKpiToDashboard.fulfilled, (state, action) => {
            state.isLoading = false;
            state.myKpis = action.payload.kpis;
            state.layout = action.payload.layout;
        })
        .addCase(addKpiToDashboard.rejected, (state) => {
            state.isLoading = false;
        })
        .addCase(getMyKpis.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getMyKpis.fulfilled, (state, action) => {
            state.isLoading = false;
            state.myKpis = action.payload.kpis;
            state.layout = action.payload.layout;
        })
        .addCase(getMyKpis.rejected, (state) => {
            state.isLoading = false;
        })
        .addCase(removeKpiFromDashboard.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(removeKpiFromDashboard.fulfilled, (state, action) => {
            state.isLoading = false;
            state.myKpis = action.payload.kpis;
            state.layout = action.payload.layout;
        })
        .addCase(removeKpiFromDashboard.rejected, (state) => {
            state.isLoading = false;
        })
        .addCase(updateDashboardLayout.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(updateDashboardLayout.fulfilled, (state, action) => {
            state.isLoading = false;
            state.layout = action.payload;
        })
        .addCase(updateDashboardLayout.rejected, (state) => {
            state.isLoading = false;
        })
}

export const getMyKpis = createAsyncThunk(
    'dashboard/getMyKpis',
    async (_, { rejectWithValue }) => {
        try {
            const response = await Get('/dashboard/', { msgKey: 'dashboard' });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch KPIs');
        }
    }
);

export const addKpiToDashboard = createAsyncThunk(
    'dashboard/addKpi',
    async (kpiData: any, { rejectWithValue }) => {
        try {
            const response = await Post('/dashboard/add-kpi', kpiData, { msgKey: 'dashboard' });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to add KPI');
        }
    }
);

export const removeKpiFromDashboard = createAsyncThunk(
    'dashboard/removeKpi',
    async (kpiId: string, { rejectWithValue }) => {
        try {
            const response = await Post('/dashboard/remove-kpi', { kpiId }, { msgKey: 'dashboard' });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to remove KPI');
        }
    }
);

export const updateDashboardLayout = createAsyncThunk(
    'dashboard/updateLayout',
    async (layoutData: any, { rejectWithValue }) => {
        try {
            const response = await Put('/dashboard/layout', layoutData, { msgKey: 'dashboard' });
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update dashboard layout');
        }
    }
);

